import React, { useEffect } from "react";
import LinkReplacementBlock from "components/LinkReplacement/LinkReplacementBlock";
import Modal from "components/Modal";
import { toggleLinkReplacementModal } from "stateManagement/reducers/modalReducer";

import { connect } from "react-redux";

/**
 * 
 * @param {{showModal:boolean,toggleModal:Function,shareUrl:string}} props
 */
const LinkReplacementModal = (props) => {

    useEffect(() => {
        if (props.showModal) {
            document.querySelector("body").style.overflow = "hidden";
        } else {
            document.querySelector("body").style.overflow = "";
        }
    }, [props.showModal]);

    return (
        <Modal isOpen={props.showModal} toggleModal={props.toggleModal} modalContentStyle={{ marginTop: ["sm"].includes(props.deviceSize) ? "60px" : "100px" }}>
            <LinkReplacementBlock
                customStyle={{ maxWidth: "100%", backgroundColor: "white" }}
                shareBlockStyle={{ border: "none", backgroundColor: "transparent" }}
                loggedInUser={props.loggedInUser}
                deviceSize={props.deviceSize}
            />
        </Modal>
    )
}

function mapStateToProps(storeState, ownProps) {
    return {
        showModal: storeState.modalReducer.showLinkReplacementModal,
    }
}

let mapDispatch = {
    toggleModal: toggleLinkReplacementModal
}
export default connect(mapStateToProps, mapDispatch)(LinkReplacementModal);